import { getAllQuestionnaires, getQuestionnaireById } from '@services/questionnaireService';
import { questionnaireActionTypes } from './actionTypes/questionnaire';
import { failure, loading, totalItems } from './commonActions';
import { Dispatch } from 'redux';
import {
  QuestionnaireEntityInterface,
  QuestionnaireQueryInterface,
  QuestionnaireRendererEntityInterface,
} from '@types';

export const setQuestionnaires = (questionnaires: QuestionnaireEntityInterface[]) => {
  return {
    type: questionnaireActionTypes.SET_QUESTIONNAIRES,
    payload: [...questionnaires],
  };
};

export const setQuestionnaire = (questionnaire: QuestionnaireEntityInterface) => {
  return {
    type: questionnaireActionTypes.SET_CURRENT_QUESTIONNAIRE,
    payload: questionnaire,
  };
};

export const setHeaderLabels = (headerLabels: string[]) => {
  return {
    type: questionnaireActionTypes.SET_CURRENT_HEADER_LABELS,
    payload: [...headerLabels],
  };
};

export const setQuestionnaireRenderer = (
  questionnaireRenderer: QuestionnaireRendererEntityInterface
) => {
  return {
    type: questionnaireActionTypes.SET_CURRENT_QUESTIONNAIRE_RENDERER,
    payload: questionnaireRenderer,
  };
};

export const makeCurrentQuestionnaire = (id: number) => {
  const instanceName = 'current_questionnaire';
  return async (dispatch: Dispatch) => {
    // Setting loading for the questionnaire
    dispatch(failure(false, instanceName));
    dispatch(loading(true, instanceName));
    try {
      const questionnaire = await getQuestionnaireById(id);
      dispatch(setQuestionnaire(questionnaire));
      dispatch(setQuestionnaireRenderer(questionnaire.renderer));
    } catch (err) {
      dispatch(failure(true, instanceName));
    } finally {
      dispatch(loading(false, instanceName));
    }
  };
};

export const makeAllQuestionnaires = (query?: QuestionnaireQueryInterface) => {
  const instanceName = 'questionnaires';

  return async (dispatch: Dispatch) => {
    dispatch(loading(true, instanceName));
    try {
      const { items, total } = await getAllQuestionnaires(query);
      dispatch(setQuestionnaires(items));
      dispatch(totalItems(total, instanceName));
    } catch (err) {
      dispatch(failure(true, instanceName));
    } finally {
      dispatch(loading(false, instanceName));
    }
  };
};
